/**
 * Client-side flag gate for the GL-7 student self-consent surface (consent
 * surface spec qlearn-gl-cohort-consent-surface-spec-v1.md D5). While
 * REACT_APP_GL_CONSENT_ENABLED is absent — the deployed default — the Settings
 * section renders NOTHING (byte-identical dark posture, the SDL/Audio-Mode
 * fail-closed discipline). The server enforces its own gate (uniform 404 while
 * qlearn.gl.consent-enabled=false) and stays authoritative; this flag is UX-only
 * and DELIBERATELY independent of the GL serving flags (REACT_APP_GL_ENABLED /
 * REACT_APP_GL_AUDIENCE) — consent is grantable while serving stays dark.
 *
 * Fail-closed: only the exact string "true" turns the surface on; absent and any
 * other value resolve to off.
 */
export const glConsentAvailable = () =>
  process.env.REACT_APP_GL_CONSENT_ENABLED === "true";
